/**
 * Repository Index
 * Central export for all repositories
 */

export { authRepository } from './auth.repository'
export type {
  LoginRequest,
  LoginResponse,
  UserProfile,
  VerifyTokenResponse,
} from './auth.repository'

export { roleRepository } from './role.repository'
export type {
  Role,
  CreateRoleRequest,
  UpdateRoleRequest,
  PaginatedResponse,
} from './role.repository'

export { rolePermissionRepository } from './role-permission.repository'
export type { RolePermission } from './role-permission.repository'

export { tenantModuleRepository } from './tenant-module.repository'
export type {
  TenantModule,
  Module,
  Permission,
} from './tenant-module.repository'

export { countryRepository } from './universe/country.repository'
export type {
  Country,
  CreateCountryRequest,
  UpdateCountryRequest,
} from './universe/country.repository'

export { regionRepository } from './universe/region.repository'
export type {
  Region,
  CreateRegionRequest,
  UpdateRegionRequest,
} from './universe/region.repository'

export { cityRepository } from './universe/city.repository'
export type {
  City,
  CreateCityRequest,
  UpdateCityRequest,
} from './universe/city.repository'

export { areaRepository } from './universe/area.repository'
export type {
  Area,
  CreateAreaRequest,
  UpdateAreaRequest,
} from './universe/area.repository'

export { districtRepository } from './universe/district.repository';
export type {
  District,
  CreateDistrictRequest,
  UpdateDistrictRequest
} from './universe/district.repository';

export { provinceRepository } from './universe/province.repository';
export type {
  Province,
  CreateProvinceRequest,
  UpdateProvinceRequest
} from './universe/province.repository';


export { uploadRepository } from './upload.repository'
export type { UploadImageResponse } from './upload.repository'

export { clientRepository } from './client.repository'
export type {
  Client,
  CreateClientRequest,
  UpdateClientRequest,
} from './client.repository'

export { clientSlaRepository } from './client-sla.repository'
export type {
  ClientSla,
  ClientSlaKpi,
  CreateClientSlaRequest,
  UpdateClientSlaRequest,
} from './client-sla.repository'

export { userRepository } from './user.repository'
export type {
  User,
  CreateUserRequest,
  UpdateUserRequest,
} from './user.repository'

export { userRoutaRepository } from './user/user-rota.repository'
export type {
  UserRouta,
  CreateUserRoutaRequest,
  UpdateUserRoutaRequest,
} from './user/user-rota.repository'

export { shiftRepository } from './shift.repository'
export type { Shift } from './shift.repository'


export { filtersAutocompleteRepository } from './filters/autocomplete.repository'
export type {
  AutocompleteItem,
  FiltersAutocompleteParams,
} from './filters/autocomplete.repository'

export { jobAssessmentRepository, jobAssessmentSectionRepository } from './job-assessment.repository'
export type {
  JobAssessmentQuestion,
  JobAssessmentSection,
  CreateJobAssessmentQuestionRequest,
  UpdateJobAssessmentQuestionRequest,
  QuestionForParentDropdown,
  CreateSectionRequest,
  UpdateSectionRequest,
} from './job-assessment.repository'

export { jobRepository, jobApplicationRepository } from './job.repository'
export type { Job, JobApplication } from './job.repository'

export { dashboardRepository } from './dashboard.repository'
export type { DashboardStats } from './dashboard.repository'

export { realogramRepository } from './realogram.repository'

export { offerLetterTemplateRepository } from './offer-letter.repository'
export type { OfferLetterTemplate } from './offer-letter.repository'

export { userOfferRepository } from './user-offer.repository'
export type { UserOffer, UserOfferStatus } from './user-offer.repository'

export { userUploadRepository } from './user-upload.repository'
export type {
  UserUploadType,
  UserSingleUploadType,
  UserUploadSingleData,
  UserUploadAssessmentData,
} from './user-upload.repository'

export { adminUserProfileRepository } from './admin-user-profile.repository'
export type { AdminUserFullProfile, AdminUpdateUserPayload } from './admin-user-profile.repository'
export { messagingRepository } from './messaging.repository'
export type { AdminChatSummary, ChatMessage } from './messaging.repository'

export {
  userQuestionnaireSelfRepository,
  userQuestionnaireAnswersSelfRepository,
  userJobsSelfRepository,
  userProfessionalQualificationsSelfRepository,
  userIqamaDetailsSelfRepository,
  userPrevJobDetailsSelfRepository,
  userProfileSelfRepository,
} from './user-self.repository'
export type {
  UserQuestionnaireRecord,
  QuestionnaireSection,
  QuestionnaireQuestion,
  UserQuestionnaireAnswerRecord,
  UserQuestionnaireCompletionRecord,
  UserJobApplicationRecord,
  UserProfessionalQualificationsRecord,
  UserIqamaDetailsRecord,
  UserPrevJobDetailsRecord,
  MyProfileRecord,
  PatchProfileChangePayload,
} from './user-self.repository'